import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule} from '@angular/forms';
import { MaterialModule } from '../../../material.module';
import { SearchComponent } from './search.component';

@NgModule({
    declarations: [SearchComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MaterialModule,
        FormsModule
    ],
    exports: [SearchComponent]
   
})
export class SearchModule { }